import React, { useEffect, useState } from "react";

import Header from "../../components/header";
import CompleteOrderRegister from "./CompleteOrderRegister";
import PendingOrderRegister from "./PendingOrderRegister";

const OrderRegister = () => {
  const [option,setOption] = useState("order")
  return (
    <>
    <Header/>
    
    <div className="p-2 max-w-[1200px] mx-auto">
      <select className="border my-2" onChange={(e)=>setOption(e.target.value)}>
        <option value="order">Order Register</option>
        <option value="pending">Pending Order Register</option>
      </select>
      {option == "order"?
        <CompleteOrderRegister />
        :
        <PendingOrderRegister />
      }
    </div>
    </>
  );
};

export default OrderRegister;
